import { ListingCategoryConst, PrefTypeConst } from '../constants';

/**
 * カレンダーのセルに出す開催表記を返す（設計 §3 の mark() 式・INV-SCH-8）。
 *
 * 🔒 この関数がセル表記の唯一の出所。区分ごとの表記をここ以外で組み立てない。
 *   mark(通常入札) = 県内・県外の2系列を「/」で連結。非開催側は ── で埋める
 *   mark(入札会)   = 開催なら「入札会」、非開催なら表記なし
 *
 * @param listingCategory 表示中の出品区分（タブ）
 * @param holdingStatus   その区分で取得した開催フラグ（Key: PrefectureType）
 *                        通常入札は [1]/[2]、入札会は [0] を見る
 */
export const markHolding = (
  listingCategory: number,
  holdingStatus: Record<number, boolean> | undefined
): string => {
  if (!holdingStatus) return "";

  if (listingCategory === ListingCategoryConst.SALE) {
    return holdingStatus[PrefTypeConst.NONE] ? "入札会" : "";
  }

  const internal = holdingStatus[PrefTypeConst.INTERNAL];
  const external = holdingStatus[PrefTypeConst.EXTERNAL];
  if (!internal && !external) return "";
  return `${internal ? "県内" : "──"}/${external ? "県外" : "──"}`;
};
